const name = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
export default { name };



// WEBPACK FOOTER //
// ./client/app/scripts/date/timezone.js